// Whether a model mapping is a stand-in (SOPS-195): the wallbox's stations run in
// eRound as a model that isn't the customer's own. That replaces the checkbox
// support used to tick. Another manufacturer always is one. For the same
// manufacturer the names are compared loosely, because eRound spells the same
// model longer ("P30 | 22kW" is "P30 | 22kW | Steckdose" there): case,
// punctuation, spaces and power such as "22kW" are ignored, and one name
// starting with the other counts as the same model.

const maker = (name: string): string => name.replace(/®/g, "").trim().replace(/\s+/g, " ").toLowerCase();

const loose = (name: string): string =>
  name
    .replace(/®/g, "")
    .toLowerCase()
    .replace(/\d+(?:[.,]\d+)?\s*kw/g, "")
    .replace(/[^a-z0-9äöüß]/g, "");

export const isStandIn = (
  onboardingManufacturer: string,
  onboardingModel: string,
  eroundManufacturer: string,
  eroundModel: string
): boolean => {
  if (maker(onboardingManufacturer) !== maker(eroundManufacturer)) return true;
  const own = loose(onboardingModel);
  const theirs = loose(eroundModel);
  return !(own && theirs && (own.startsWith(theirs) || theirs.startsWith(own)));
};
